import { useMutation } from '@tanstack/react-query';
// import {
//     CameraCCTVModel,
//     CameraModel,
//     ICameraCCTVModel,
//     ICameraModel,
//     IProjectModel,
//     IUserModel,
//     ProjectModel,
//     UserModel,
// } from 'api/models';
// import { getSearchResults } from 'api/services';
import { useCallback, useMemo, useRef, useState } from 'react';
import { SearchTypeEnum } from '../enums/searchbar.enums';
import { getSearchResults } from '@api/services/search.service';
import { ICameraCCTV, IClient, IProject, IUser } from '@api/models';
import { IFolderSearch } from '../components/SearchResultRow/SearchResultRow';

const useSearchQuery = () => {
    const [projects, setProjects] = useState<IProject[]>([]);
    const [users, setUsers] = useState<IUser[]>([]);
    const [clients, setClients] = useState<IClient[]>([]);
    const [folder, setFolder] = useState<IFolderSearch[]>([]);
    const [liveCameras, setLiveCameras] = useState<ICameraCCTV[]>([]);

    const ref = useRef(null);

    const searchProjectsMutation = useMutation((q: string) => getSearchResults<IProject>('projects', q));
    const searchUsersMutation = useMutation((q: string) => getSearchResults<IUser>('users', q));
    const searchClientsMutation = useMutation((q: string) => getSearchResults<IClient>('clients', q));
    const searchFolderMutation = useMutation((q: string) => getSearchResults<IFolderSearch>('folder', q));
    const searchLiveCameraMutation = useMutation((q: string) => getSearchResults<ICameraCCTV>('camera-cctvs', q));

    const fetch = useCallback(
        (q: string) => {
            ref.current = q;

            searchProjectsMutation.mutateAsync(q).then((result) => {
                if (result.q === ref.current) setProjects(result.data.map((row) => row));
            });

            searchUsersMutation.mutateAsync(q).then((result) => {
                if (result.q === ref.current) setUsers(result.data.map((row) => row));
            });
            searchClientsMutation.mutateAsync(q).then((result) => {
                if (result.q === ref.current) setClients(result.data.map((row) => row));
            });

            searchFolderMutation.mutateAsync(q).then((result) => {
                if (result.q === ref.current) setFolder(result.data.map((row) => row));
            });
            searchLiveCameraMutation.mutateAsync(q).then((result) => {
                if (result.q === ref.current) setLiveCameras(result.data.map((row) => row));
            });
        },
        [
            searchProjectsMutation,
            searchUsersMutation,
            searchFolderMutation,
            searchClientsMutation,
            searchLiveCameraMutation,
        ]
    );

    const resetResults = useCallback(() => {
        setProjects([]);
        setUsers([]);
        setFolder([]);
        setClients([]);
        setLiveCameras([]);
    }, []);

    const groups = useMemo(() => {
        return [
            {
                type: SearchTypeEnum.PROJECT,
                label: 'Projects',
                isLoading: searchProjectsMutation.isLoading,
                data: projects,
            },

            {
                type: SearchTypeEnum.USER,
                label: 'Users',
                isLoading: searchUsersMutation.isLoading,
                data: users,
            },
            {
                type: SearchTypeEnum.CLIENT,
                label: 'Clients',
                isLoading: searchClientsMutation.isLoading,
                data: clients,
            },
            {
                type: SearchTypeEnum.FOLDER,
                label: 'Folder',
                isLoading: searchFolderMutation.isLoading,
                data: folder,
            },
            {
                type: SearchTypeEnum.CAMERA_CCTV,
                label: 'QLive Unit',
                isLoading: searchLiveCameraMutation.isLoading,
                data: liveCameras,
            },
        ];
    }, [
        projects,
        users,
        clients,
        folder,
        liveCameras,
        searchProjectsMutation.isLoading,
        searchUsersMutation.isLoading,
        searchClientsMutation.isLoading,
        searchFolderMutation.isLoading,
        searchLiveCameraMutation.isLoading,
    ]);

    return {
        fetch,
        resetResults,
        groups,
        isEmpty: groups.every((group) => group.data.length === 0),
        isLoading: groups.some((group) => group.isLoading),
    };
};

export default useSearchQuery;
